import { memo, useState } from 'react';
import { useDebounce } from 'react-use';

import { GeneralSelector } from '../GeneralSelector/GeneralSelector';
import { useTaxCodes } from './TaxCodeCell.hooks';
import { messages } from './TaxCodeCell.messages';
import { TaxCodeCellProps } from './TaxCodeCell.types';

export const TaxCodeCell = memo<TaxCodeCellProps>((props) => {
    const { cellProps, disabled } = props;

    const [query, setQuery] = useState('');
    const [debouncedQuery, setDebouncedQuery] = useState('');
    const { taxCodes, isLoading } = useTaxCodes(debouncedQuery, cellProps?.item.index);

    useDebounce(() => setDebouncedQuery(query), 500, [query]);

    if (!cellProps) return null;

    return (
        <GeneralSelector
            name='taxCode'
            items={taxCodes}
            placeholder={messages.placeholder}
            progress={isLoading}
            onInputChange={setQuery}
            cellProps={cellProps}
            disabled={disabled}
        />
    );
});

TaxCodeCell.displayName = 'TaxCodeCell';
